<template>
  <div >
    <el-container>
      <el-header>
        <div style="margin: 10px 0">
          <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 300px;"></el-input>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>
        </div>
      </el-header>
      <el-main>
        <template>
          <el-table
            :data="tableData"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="customerName"
              label="名称"
              width="300">
            </el-table-column>
            <!--<el-table-column
              prop="class"
              label="客户分类"
              width="220">
            </el-table-column>-->
            <el-table-column
              prop="endTime"
              :formatter="formatTime"
              label="最后同步时间"
              width="300">
            </el-table-column>
            <el-table-column
              prop="identification"
              label="标识"
              width="180">
            </el-table-column>
            <el-table-column
              prop="updateTime"
              fixed="right"
              :formatter="formatTime"
              label="最后统计时间"
              width="200">
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        serchat:"",
        dropdownTitle:"请选择",
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        dropdownList:[]
      }
    },
    methods:{
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      isAjax:async function(){
        await this.$axios.post('/data/addSynchronization',{
          d:this.dropdownTitle,
          s:this.serchat,
          "count":this.count0,
          "page":this.currentPage0
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
            this.divHeight = window.innerHeight-158;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });

      }
    },
    mounted(){
      this.addClass();
      this.isAjax();
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/synchronization.vue